import { ActionIcon, Menu, UnstyledButton, rem } from '@mantine/core';
import { Link, NavLink } from 'react-router-dom';

import { IconDots } from '@tabler/icons-react';

const MenuButtonItem = ({ text, onClick }) => {
    return (
        <Menu.Item
            component={UnstyledButton}
            onClick={onClick}>
            {text}
        </Menu.Item>
    );
};

const MenuLinkItem = ({ text, path }) => {
    return (
        <Menu.Item
            component={NavLink}
            to={path}>
            {text}
        </Menu.Item>
    );
};

const ActionsColumn = ({
    row: { original: rowData },
    openTimelineModal,
    setModalItem,
}) => {
    const dropdownOptions = [
        {
            text: 'Send Timeline',
            onClick: (e) => {
                setModalItem(rowData);
                openTimelineModal();
            },
        },
    ];
    return (
        <Menu disabled={false}>
            <Menu.Target>
                <ActionIcon
                    color={'dimmed'}
                    variant='transparent'
                    disabled={false}>
                    <IconDots stroke={1.5} />
                </ActionIcon>
            </Menu.Target>
            <Menu.Dropdown>
                {dropdownOptions.map((x, i) =>
                    x.path ? (
                        <MenuLinkItem
                            key={i}
                            {...x}
                        />
                    ) : (
                        <MenuButtonItem
                            key={i}
                            {...x}
                        />
                    )
                )}
            </Menu.Dropdown>
        </Menu>
    );
};
export default ActionsColumn;
